/* Product-page reading and focus support. No purchase, catalog or tracking logic. */
(() => {
  const product = document.querySelector('.keast-product-refresh');
  if (!product) return;

  const tables = [...product.querySelectorAll('.keast-product-table')];
  const rails = [...document.querySelectorAll('.keast-trust__people-grid, .keast-trust__category-grid')];
  const galleries = [...product.querySelectorAll('.product__media-list')];
  const sticky = document.querySelector('[data-keast-sticky-purchase]');
  const scrollRegions = [...tables, ...rails, ...galleries];
  galleries.forEach((gallery) => {
    if (!gallery.hasAttribute('aria-label')) gallery.setAttribute('aria-label', 'Product media');
  });

  tables.forEach((wrapper) => {
    const table = wrapper.querySelector('table');
    if (!table) return;
    const first = table.rows[0];
    const labels = first ? [...first.cells].map((cell) => cell.textContent.trim().toLowerCase()) : [];
    // Repair only the unambiguous, existing two-column specification format.
    if (labels.length === 2 && labels[0] === 'specification' && labels[1] === 'details') {
      [...table.rows].forEach((row, index) => {
        const cells = index === 0 ? [...row.cells] : [row.cells[0]];
        cells.filter(Boolean).forEach((cell) => {
          if (cell.tagName === 'TH') {
            if (!cell.hasAttribute('scope')) cell.scope = index === 0 ? 'col' : 'row';
            return;
          }
          const header = document.createElement('th');
          [...cell.attributes].forEach((attribute) => header.setAttribute(attribute.name, attribute.value));
          header.scope = index === 0 ? 'col' : 'row';
          header.append(...cell.childNodes);
          cell.replaceWith(header);
        });
      });
    }
    if (!table.caption && !table.hasAttribute('aria-label') && !table.hasAttribute('aria-labelledby')) {
      table.setAttribute('aria-label', labels[0] === 'specification' ? 'Product specifications' : 'Product details');
    }
    wrapper.dataset.keastScrollLabel = table.getAttribute('aria-label') || table.caption?.textContent.trim() || 'Product details table';
  });

  let frame;
  const updateLayout = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      // Read all geometry before updating presentation attributes.
      const overflowing = scrollRegions.map((region) => region.scrollWidth > region.clientWidth + 1);
      const naturalStickyHeight = sticky?.getBoundingClientRect().height || 0;
      const suppressSticky = naturalStickyHeight > Math.min(160, innerHeight * 0.25);
      const stickyHeight = sticky?.classList.contains('is-visible') && !suppressSticky ? naturalStickyHeight : 0;
      scrollRegions.forEach((region, index) => {
        if (overflowing[index]) {
          region.tabIndex = 0;
          if (region.classList.contains('keast-product-table')) {
            region.setAttribute('role', 'region');
            region.setAttribute('aria-label', region.dataset.keastScrollLabel);
          }
        } else {
          region.removeAttribute('tabindex');
          if (region.classList.contains('keast-product-table')) {
            region.removeAttribute('role');
            region.removeAttribute('aria-label');
          }
        }
      });
      sticky?.classList.toggle('keast-sticky-overflow', suppressSticky);
      document.body.style.setProperty('--keast-sticky-height', `${Math.ceil(stickyHeight)}px`);
    });
  };
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(updateLayout);
    scrollRegions.forEach((region) => observer.observe(region));
    if (sticky) observer.observe(sticky);
  }
  window.addEventListener('resize', updateLayout, { passive: true });
  if (sticky) {
    // Visibility can change on scroll without changing the bar's dimensions.
    new MutationObserver((records) => {
      const visible = sticky.classList.contains('is-visible');
      if (records.some((record) => (record.oldValue || '').split(/\s+/).includes('is-visible') !== visible)) updateLayout();
    }).observe(sticky, { attributes: true, attributeOldValue: true, attributeFilter: ['class'] });
  }
  updateLayout();

  product.addEventListener('click', (event) => {
    const link = event.target.closest('[data-keast-shipping-details]');
    if (!link) return;
    const details = document.getElementById(link.hash.slice(1));
    if (!details) return;
    event.preventDefault();
    details.open = true;
    const summary = details.querySelector('summary');
    summary?.focus({ preventScroll: true });
    summary?.scrollIntoView({ block: 'center', behavior: 'instant' });
  });

  document.addEventListener('focusin', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement) || !target.matches(':focus-visible')) return;
    if (target.closest('[data-keast-question-dialog], [data-keast-sticky-purchase]')) return;
    requestAnimationFrame(() => {
      const box = target.getBoundingClientRect();
      const headerBottom = document.querySelector('.shopify-section-header-sticky')?.getBoundingClientRect().bottom || 0;
      const stickyTop = sticky && getComputedStyle(sticky).visibility !== 'hidden' ? sticky.getBoundingClientRect().top : innerHeight;
      if (box.top < Math.max(0, headerBottom) || box.bottom > stickyTop) {
        target.scrollIntoView({ block: 'center', behavior: 'instant' });
      }
    });
  });
})();
